import { PortalWrapper, Provider, WidgetWrapper } from '@libs/core';
import { setStatus } from '@libs/store';
import { EStatus } from '@libs/types';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function ClearSessionPage() {
    const navigation = useNavigate();

    useEffect(() => {
        setStatus(EStatus.Loading);
        localStorage?.clear?.();
        navigation('/', { replace: true });
    }, [navigation]);

    return (
        <Provider>
            <WidgetWrapper>
                <PortalWrapper>
                    <p></p>
                </PortalWrapper>
            </WidgetWrapper>
        </Provider>
    );
}
